import { useSyncExternalStore } from 'react'
import {
  getPhotoPlacementOverridesSnapshot,
  subscribePhotoPlacementOverrides,
} from '@/lib/photos/photo-placement-session'

export function usePhotoPlacementOverrides(): ReadonlyMap<string, boolean> {
  return useSyncExternalStore(
    subscribePhotoPlacementOverrides,
    getPhotoPlacementOverridesSnapshot,
    getPhotoPlacementOverridesSnapshot
  )
}
